import addClasses from './addClasses';
import removeClasses from './removeClasses';
export default {
  addClasses: addClasses,
  removeClasses: removeClasses
};


//////////////////
// WEBPACK FOOTER
// ./~/swiper/esm/components/core/classes/index.js
// module id = 710
// module chunks = 169